import * as ROUTES from '../routes';


const Navigations = [
    {
        title: "Gift Cards",
        icon: "mdi-wallet-giftcard",
        to: ROUTES.GIFTCARDSTORE,
        mini: false,
        permissions: ['can_view_giftcards'],
        subNav: [
            {
                title: "Stores",
                to: ROUTES.GIFTCARDSTORE,
                icon: 'mdi-wallet-giftcard'
            },
            {
                title: "Statistics",
                to: ROUTES.GIFTCARDSTATS,
                icon: 'mdi-chart-bar'
            },
            {
                title: "Hottest",
                to: ROUTES.HOTTEST,
                icon: 'mdi-chart-bar'
            },
            

        ],
    },
    {
        title: "Giftcard Trades ",
        icon: "mdi-chat",
        to: ROUTES.GIFTCARDTRANSACTIONS,
        mini: "",
        permissions: ['can_view_giftcard_trades']
    },
]

export default Navigations